module.exports = __webpack_public_path__ + "img/tiktok2.729b0380.svg";